<template>
  <mi-dialog
    :model-value="modelValue"
    class="configuration-restore-empty-dialog"
    @update:model-value="emitUpdateModelValue"
  >
    <!-- Title -->
    <h5 class="q-mt-md q-mb-md"> Adding an empty restore point </h5>

    <!-- Subtitle -->
    <p class="q-mb-xl">
      There is no choice selected, this will add an empty restore point. Do you want to continue?
    </p>

    <template #actions>
      <!-- Cancel button -->
      <mi-btn v-close-popup flat> Cancel </mi-btn>

      <!-- Submit button -->
      <mi-btn class="continue-btn" @click="closeAndCreateRestorePoint"> Continue </mi-btn>
    </template>
  </mi-dialog>
</template>

<script>
  export default {
    name: 'ConfigurationRestoreEmptyDialog',
    props: {
      modelValue: {
        type: Boolean,
        required: true
      },
      createRestorePoint: {
        type: Function,
        required: true
      }
    },
    emits: ['update:model-value'],
    setup(props, { emit }) {
      const emitUpdateModelValue = (value = false) => {
        emit('update:model-value', value)
      }

      const closeAndCreateRestorePoint = async () => {
        await emitUpdateModelValue()
        await props.createRestorePoint()
      }

      return {
        closeAndCreateRestorePoint,
        emitUpdateModelValue
      }
    }
  }
</script>

<style lang="scss">
  .configuration-restore-empty-dialog {
    .q-dialog__inner > .mi-card {
      width: 682px;
      max-width: 682px;
      min-width: 682px;
      height: 293px;
    }

    h5 {
      font-size: 28px;
    }

    .mi-btn {
      font-size: 18px;
      height: 50px;
    }

    .continue-btn {
      width: 117px;
    }

    .q-card__section:nth-child(2) {
      height: 160px;
    }
  }

  @media (max-width: $mi-responsive-large-width) {
    .configuration-restore-empty-dialog {
      .q-dialog__inner > .mi-card {
        width: 682px;
        max-width: 682px;
        height: 293px;
      }
    }
  }

  @media (max-width: $mi-responsive-medium-width) {
    .configuration-restore-empty-dialog {
      .q-dialog__inner > .mi-card {
        width: 682px;
        max-width: 682px;
        height: 293px;
      }
    }
  }
</style>
